// @ts-check

import { createWidget } from "@opendash/core";



export default createWidget({
  type: "opendash-widget-bcm-contacts",
  meta: {},
  displayComponent: () => import("./component"),
  settingsComponent: () => import("./settings"),
  presets: [
    {
      label: "bcm:widgets.contacts.name",
      description: "bcm:widgets.contacts.description",
      imageLink: require("./screenshot.png"),
      layout: [6, 8],
      widget: {
        config: {
          blocklist: [],
        },
      },
    },
  ],
});
